// @flow

import PropertyTypeValueField from './components/form/PropertyTypeValueField';

export const components = {
    'formPaneField:PROPERTY_TYPE_VALUE': PropertyTypeValueField,    
}
